<template>
<!--  <van-action-sheet-->
<!--    :value="visible"-->
<!--    :close-on-click-overlay="false"-->
<!--    :close-on-popstate="false"-->
<!--    @close="hide"-->
<!--    @click-overlay="hide"-->
<!--    position="bottom"-->
<!--    get-container="#engine"-->
<!--  >-->
  <div class='pickerControl'  v-show='visible'>
    <div class="picker-view">
      <p v-if="title" class="picker-title">{{ title }}</p>
      <div class="picker-content">
        <slot></slot>
      </div>
    </div>
    
  </div>

<!--  </van-action-sheet>-->
</template>
<script>
export default {
  name: "Picker",
  model: {
    prop: "visible",
    event: "change",
  },
  props: {
    title: String,
    visible: Boolean,
  },
  methods: {
    hide() {
      this.$emit("change", false);
    },
  },
};
</script>
<style lang='scss' scoped>
.pickerControl{
  background: #FFFFFF;
  width: 100vw;
  height: 90vh;
  position: fixed;
  bottom: 0;
  z-index: 888;
}
.picker-view{

}
</style>
